import { ApiResponse, PaginationResponseBase, PartBaseResponse } from '../interfaces/ApiResponses';
import { apiServiceInstance } from '../helpers/utils';

export type BoPhanListParams = {
  /** Search `ten_bo_phan` / `ma_bo_phan` */
  q?: string;
  /** Admin tables — Laravel paginator. Omit for select dropdowns (full array). */
  paginate?: boolean;
  page?: number;
};

function normalizeBoPhanList(
  data: PartBaseResponse[] | PaginationResponseBase<PartBaseResponse>
): PartBaseResponse[] {
  if (Array.isArray(data)) {
    return data;
  }
  return data?.data || [];
}

export default class BoPhanService {
  /**
   * Default API shape is a full array (for selects).
   * Pass `paginate: true` for admin table paging.
   */
  static list(params: BoPhanListParams = {}): Promise<{
    data: ApiResponse<
      PartBaseResponse[] | PaginationResponseBase<PartBaseResponse>
    >;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      '/api/v1/bo-phan/danh-sach',
      {
        params: {
          ...(params.q ? { q: params.q } : {}),
          ...(params.paginate ? { paginate: 1 } : {}),
          ...(params.page ? { page: params.page } : {}),
        },
      }
    );
  }

  /** Full catalog for `<el-select>` / dropdowns (no paginate). */
  static async listForSelect(q?: string): Promise<PartBaseResponse[]> {
    const {
      data: { data },
    } = await BoPhanService.list(q ? { q } : {});
    return normalizeBoPhanList(data);
  }

  /** Null-safe: missing / orphan / id<=0 returns `data: null` (HTTP 200). */
  static get(id: number): Promise<{
    data: ApiResponse<PartBaseResponse | null>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      `/api/v1/bo-phan/chi-tiet/${id}`
    );
  }

  static new(
    departmentId: number,
    name: string,
    code: string,
    address: string,
    description: string
  ): Promise<{
    data: ApiResponse<PartBaseResponse>;
  }> {
    apiServiceInstance().vueInstance.axios.defaults.headers.common[
      'Content-Type'
    ] = 'multipart/form-data';
    const bodyFormData = new FormData();
    bodyFormData.append('boPhanInstance[id_don_vi]', departmentId.toString());
    bodyFormData.append('boPhanInstance[ten_bo_phan]', name);
    bodyFormData.append('boPhanInstance[ma_bo_phan]', code);
    bodyFormData.append('boPhanInstance[dia_chi]', address);
    bodyFormData.append('boPhanInstance[mo_ta]', description);
    return apiServiceInstance().vueInstance.axios.post(
      '/api/v1/bo-phan/tao-moi',
      bodyFormData
    );
  }

  static update(
    id: number,
    departmentId: number,
    name: string,
    code: string,
    address: string,
    description: string
  ): Promise<{
    data: ApiResponse<PartBaseResponse>;
  }> {
    apiServiceInstance().vueInstance.axios.defaults.headers.common[
      'Content-Type'
    ] = 'multipart/form-data';
    const bodyFormData = new FormData();
    bodyFormData.append('boPhanInstance[id_don_vi]', departmentId.toString());
    bodyFormData.append('boPhanInstance[ten_bo_phan]', name);
    bodyFormData.append('boPhanInstance[ma_bo_phan]', code);
    bodyFormData.append('boPhanInstance[dia_chi]', address);
    bodyFormData.append('boPhanInstance[mo_ta]', description);
    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/bo-phan/cap-nhat/${id}`,
      bodyFormData
    );
  }
}
